// ======================================================================
// File Name       : UsageSettingLiveActions
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as usageSettingLiveRequest from './httpRequests/usageSettingLive';
import * as usageSettingLiveActionCreators from './actionCreators/usageSettingLive/usageSettingLive';
import * as GroupAction from './GroupAction';
import * as UserAction from './UserAction';
import * as userRequest from './httpRequests/user';
import * as groupRequests from './httpRequests/group';
import * as userAttributeRequests from './httpRequests/userAttribute';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM, WRITE, MODE } from '../constants';
import { USER_ATTRIBUTE_TYPE } from '../constants/UserAttributeConstants';
import { isSuperUser } from '../utils/UserUtils';
import { commonCallApi } from '../utils/ApiUtils';
import { USER_CREATE_TYPE } from '../constants/UserConstants';

export function getLiveReservationTime() {
  return async (dispatch, getState) => {
    const liveReservationTimeRes = await usageSettingLiveRequest.getLiveReservationTime();
    return dispatch(
      usageSettingLiveActionCreators.receivedLiveReservationTime(liveReservationTimeRes),
    );
  };
}

export function initDataForRegisterEdit(isRegister) {
  return async (dispatch, getState) => {
    const { authedUser } = getState().authed;
    const { serviceInfo } = getState().usageSettingLive;

    if (authedUser && authedUser.userInfo && authedUser.userInfo.userSecernId) {
      const myUserInfo = authedUser.userInfo;
      if (!isSuperUser(myUserInfo.displayUserType) && isRegister) {
        await dispatch(UserAction.storeMyUserInfo(authedUser.userInfo));
      }
    }
    const shouldGetServiceInfo =
      authedUser &&
      authedUser.serviceCd &&
      (!serviceInfo || serviceInfo.serviceCd !== authedUser.serviceCd);
    if (shouldGetServiceInfo) {
      const param = {};
      param.selectTargetData = SELECT_TARGET_DATA.DATA;
      authedUser.institutionId && (param.institutionId = authedUser.institutionId);
      authedUser.enterpriseId && (param.enterpriseId = authedUser.enterpriseId);
      const searchInfo = {
        serviceCdList: [authedUser.serviceCd],
      };
      param.searchInfo = searchInfo;
      const serviceInfoRes = await usageSettingLiveRequest.getServiceList(param);
      if (serviceInfoRes && serviceInfoRes.serviceList && serviceInfoRes.serviceList.length) {
        const newServiceInfo = serviceInfoRes.serviceList[0];
        dispatch(usageSettingLiveActionCreators.receivedServiceInfo(newServiceInfo));
      }
    }
    return dispatch(getLiveReservationTime());
  };
}

export function getLiveReservedList({ paramSearchInfo, paramSearchAttribute }) {
  return async (dispatch, getState) => {
    let liveReserves = { recordNum: 0, liveList: [] };
    let liveUserCountList = [];
    let userListToStore = [];
    let liveSecernIds = null;
    const { storedUserList } = getState().usageSettingLive;
    if (paramSearchAttribute && paramSearchAttribute.userAttributeSearchText) {
      const { userAttributeList } = await userAttributeRequests.postUserAttributeGetList({
        searchInfo: {
          userAttributeType: USER_ATTRIBUTE_TYPE.LIVE,
          userAttributeKeyNum: paramSearchAttribute.userAttributeKeyNum,
          userAttributeSearchText: paramSearchAttribute.userAttributeSearchText,
        },
      });
      if (!userAttributeList || !userAttributeList.length) {
        return dispatch(
          usageSettingLiveActionCreators.receivedLiveReservedList(
            liveReserves,
            userListToStore,
            liveUserCountList,
          ),
        );
      }
      liveSecernIds = userAttributeList.reduce((acc, cur) => {
        if (cur.secernId) {
          acc.push(cur.secernId);
        }
        return acc;
      }, []);

      if (liveSecernIds && liveSecernIds.length) {
        paramSearchInfo.liveList = liveSecernIds;
      }
    }
    const resData = await usageSettingLiveRequest.getLiveReservedList({
      searchInfo: paramSearchInfo,
    });
    if (resData && resData.liveList && resData.liveList.length) {
      liveReserves = resData;
      const liveList = liveReserves.liveList;
      const lives = liveList.reduce(
        (acc, cur) => {
          if (cur.liveSecernId) {
            acc.liveSecernIdList.push(cur.liveSecernId);
          }
          if (cur.organizerUserSecernId && !storedUserList.bySecernIds[cur.organizerUserSecernId]) {
            acc.userSecernIdList.push(cur.organizerUserSecernId);
          }
          return acc;
        },
        {
          userSecernIdList: [],
          liveSecernIdList: [],
        },
      );
      if (lives && lives.liveSecernIdList && lives.liveSecernIdList.length) {
        const searchCountInfo = {
          liveList: lives.liveSecernIdList,
        };
        const liveUserCountRes = await getEachLiveUserCountList({ searchInfo: searchCountInfo });
        if (liveUserCountRes && liveUserCountRes.liveList && liveUserCountRes.liveList.length) {
          liveUserCountList = liveUserCountRes.liveList;
        }
      }
      if (lives && lives.userSecernIdList && lives.userSecernIdList.length) {
        const searchInfo = {
          userSecernIdList: lives.userSecernIdList,
          userCreateType: USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER,
        };
        const userListRes = await userRequest.postUserGetList({
          selectTargetData: SELECT_TARGET_DATA.DATA,
          searchInfo,
        });
        if (userListRes && userListRes.userList && userListRes.userList.length) {
          userListToStore = userListRes.userList;
        }
      }
    }
    return dispatch(
      usageSettingLiveActionCreators.receivedLiveReservedList(
        liveReserves,
        userListToStore,
        liveUserCountList,
      ),
    );
  };
}

function fetchUser(searchInfo = {}) {
  return userRequest.postUserGetList({
    selectTargetData: SELECT_TARGET_DATA.DATA,
    searchInfo,
  });
}

export function getLiveReservedDetail(params) {
  return async (dispatch, getState) => {
    let liveReserveDetail = {};
    let userLiveRelationList = [];
    let userSecernIdList = [];
    let userAttributeList = [];
    let userLiveRecordedFileList = [];
    let { storedUserList } = getState().user;
    const { structures } = getState().group;
    const { bySecernIds } = storedUserList;

    const resData = await usageSettingLiveRequest.getLiveReservedList(params);
    if (resData && resData.liveList && resData.liveList.length) {
      liveReserveDetail = resData.liveList[0];
    } else {
      return dispatch(
        usageSettingLiveActionCreators.receivedLiveReservedDetail(
          liveReserveDetail,
          storedUserList,
          userLiveRelationList,
          userAttributeList,
        ),
      );
    }

    if (liveReserveDetail && liveReserveDetail.liveSecernId) {
      const userAttributeRes = await userAttributeRequests.postUserAttributeGetList({
        searchInfo: {
          userAttributeType: USER_ATTRIBUTE_TYPE.LIVE,
          secernId: liveReserveDetail.liveSecernId,
        },
      });
      if (
        userAttributeRes &&
        userAttributeRes.userAttributeList &&
        userAttributeRes.userAttributeList.length
      ) {
        userAttributeList = userAttributeRes.userAttributeList;
      }
    }

    if (
      liveReserveDetail.organizerUserSecernId &&
      (!bySecernIds || !bySecernIds[liveReserveDetail.organizerUserSecernId])
    ) {
      userSecernIdList.push(liveReserveDetail.organizerUserSecernId);
    }
    const userLiveRelationRes = await getUserLiveRelationList({
      searchInfo: {
        liveList: [liveReserveDetail.liveSecernId],
      },
    });
    if (
      userLiveRelationRes &&
      userLiveRelationRes.liveRelationList &&
      userLiveRelationRes.liveRelationList.length
    ) {
      userLiveRelationList = userLiveRelationRes.liveRelationList;
      const userSecernIdToSearch = userLiveRelationList.reduce((acc, cur) => {
        if (cur.participantUserSecernId) {
          const participantUserSecernId = cur.participantUserSecernId;
          if (
            acc.indexOf(participantUserSecernId) < 0 &&
            (!bySecernIds || !bySecernIds[cur.participantUserSecernId]) &&
            userSecernIdList.indexOf(participantUserSecernId) < 0
          ) {
            acc.push(cur.participantUserSecernId);
          }
        }
        return acc;
      }, []);
      if (userSecernIdToSearch && userSecernIdToSearch.length) {
        userSecernIdList = userSecernIdList.concat(userSecernIdToSearch);
      }
    }
    if (userSecernIdList && userSecernIdList.length) {
      const paramSearchInfo = {
        userSecernIdList,
      };
      await dispatch(UserAction.searchUserOnDialog({ paramSearchInfo }, true, true));
      storedUserList = getState().user.storedUserList;
    }

    const userLiveRecordedFileRes = await getUserLiveRecordedFileList({
      searchInfo: {
        liveSecernId: liveReserveDetail.liveSecernId,
      },
    });
    if (
      userLiveRecordedFileRes &&
      userLiveRecordedFileRes.recordList &&
      userLiveRecordedFileRes.recordList.length
    ) {
      userLiveRecordedFileList = userLiveRecordedFileRes.recordList;
    }
    return dispatch(
      usageSettingLiveActionCreators.receivedLiveReservedDetail(
        liveReserveDetail,
        storedUserList,
        userLiveRelationList,
        userAttributeList,
        userLiveRecordedFileList,
      ),
    );
  };
}

function getUserLiveRelationList(params) {
  return usageSettingLiveRequest.getUserLiveRelationList(params);
}

function getEachLiveUserCountList(params) {
  return usageSettingLiveRequest.getEachLiveUserCountList(params);
}

export function registerLiveReservation({
  paramLiveReserved,
  paramLiveUserRelation,
  paramUserAttributes,
}) {
  return async (dispatch) => {
    try {
      const liveReservationRes = await usageSettingLiveRequest.registerEditLiveReservation(
        paramLiveReserved,
      );
      if (liveReservationRes && liveReservationRes.liveSecernId) {
        if (
          paramLiveUserRelation &&
          paramLiveUserRelation.liveInfo &&
          paramLiveUserRelation.liveInfo.userList &&
          paramLiveUserRelation.liveInfo.userList.length
        ) {
          paramLiveUserRelation.liveInfo.liveSecernId = liveReservationRes.liveSecernId;
          await usageSettingLiveRequest.registerEditLiveUserRelation(paramLiveUserRelation);
        }
        if (
          paramUserAttributes &&
          paramUserAttributes.userAttributeList &&
          paramUserAttributes.userAttributeList.length
        ) {
          paramUserAttributes.secernId = liveReservationRes.liveSecernId;
          await userAttributeRequests.postUserAttributeEdit(paramUserAttributes);
        }
      }
      return null;
    } catch (error) {
      return error;
    }
  };
}

export function editLiveReservation({
  paramLiveReserved,
  paramLiveUserRelation,
  paramUserAttributes,
}) {
  return async (dispatch) => {
    try {
      const liveReservationRes = await usageSettingLiveRequest.registerEditLiveReservation(
        paramLiveReserved,
      );
      if (liveReservationRes && liveReservationRes.liveSecernId) {
        if (paramLiveUserRelation) {
          const params = {};
          params.liveInfo = {};
          params.liveInfo.liveSecernId = liveReservationRes.liveSecernId;
          if (paramLiveUserRelation.newUsers && paramLiveUserRelation.newUsers.length) {
            params.editType = MODE.NEW_MODE;
            params.liveInfo.userList = paramLiveUserRelation.newUsers;
            await usageSettingLiveRequest.registerEditLiveUserRelation(params);
          }

          if (paramLiveUserRelation.deletingUsers && paramLiveUserRelation.deletingUsers.length) {
            params.editType = MODE.DELETE_MODE;
            params.liveInfo.userList = paramLiveUserRelation.deletingUsers;
            await usageSettingLiveRequest.registerEditLiveUserRelation(params);
          }
        }
        if (
          paramUserAttributes &&
          paramUserAttributes.userAttributeList &&
          paramUserAttributes.userAttributeList.length
        ) {
          paramUserAttributes.secernId = liveReservationRes.liveSecernId;
          await userAttributeRequests.postUserAttributeEdit(paramUserAttributes);
        }
      }
      return null;
    } catch (error) {
      return error;
    }
  };
}

export function deleteLiveReservation(paramLive, paramUserLiveRelation) {
  return async (dispatch) => {
    try {
      await usageSettingLiveRequest.registerEditLiveReservation(paramLive);
      return null;
    } catch (error) {
      return error;
    }
  };
}

export function addUsersToList(userListToAdd) {
  return async (dispatch, getState) => {
    const { storedUserList } = getState().user;
    await dispatch(usageSettingLiveActionCreators.addUsersToList(userListToAdd, storedUserList));
    return {};
  };
}

export function removeUserFromList(userSecernId) {
  return dispatch => dispatch(usageSettingLiveActionCreators.removeUserFromList(userSecernId));
}

export function resetEdittingUsers() {
  return dispatch => dispatch(usageSettingLiveActionCreators.resetEdittingUsers());
}

export function getLiveAuthorityList() {
  return async (dispatch, getState) => {
    let liveAuthorityIdList = [];
    const authorityListRes = await userRequest.getUserAuthorityList();
    if (
      authorityListRes &&
      authorityListRes.managementAuthorityList &&
      authorityListRes.managementAuthorityList.length
    ) {
      liveAuthorityIdList = authorityListRes.managementAuthorityList.reduce((acc, cur) => {
        if (
          cur &&
          cur.managementAuthoritySecernId &&
          cur.managementFunctionAuthorityInfo &&
          cur.managementFunctionAuthorityInfo.liveManagementAuthority === WRITE
        ) {
          acc.push(cur.managementAuthoritySecernId);
        }
        return acc;
      }, []);
    }
    return dispatch(usageSettingLiveActionCreators.saveLiveAuthorityIds(liveAuthorityIdList));
  };
}

export function getJoinableLiveList(params) {
  return async (dispatch) => {
    const joinableLives = { userSecernId: '', liveList: [] };
    const joinableLiveRes = await usageSettingLiveRequest.getJoinableLiveList(params);
    if (joinableLiveRes && joinableLiveRes.liveList && joinableLiveRes.liveList.length) {
      joinableLives.userSecernId = joinableLiveRes.userSecernId;
      joinableLives.liveList = joinableLiveRes.liveList;
    }
    return dispatch(usageSettingLiveActionCreators.receiveJoinableLiveList(joinableLives));
  };
}

export function getUserLiveRecordedFileList(params) {
  return usageSettingLiveRequest.getUserLiveRecordedFileList(params);
}

export function downloadRecordedVideo(params) {
  return (dispatch) => {
    commonCallApi({
      path: 'live/GetRecordedVideoDownloadURL',
      data: params,
    })
      .then((camelizeJson) => {
        if (camelizeJson && camelizeJson.recordDownloadUrl) {
          const link = document.createElement('a');
          link.href = camelizeJson.recordDownloadUrl;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
  };
}

// #7129 START
export function resetLiveReservedDetail() {
  return async dispatch => dispatch(usageSettingLiveActionCreators.resetLiveReservedDetail());
}
// #7129 END

